module.exports = __webpack_public_path__ + "img/102.a1d94aab.svg";